import deb from "./videos/deb";
import jeffrey from "./videos/jeffrey";
import sarah from "./videos/sarah";
import stacey from "./videos/stacey";


const videos = [
  
  {
    id: "sarah",
    sources: [
      {
        type: "video/mp4",
        src: "https://www.mckinsey.com/spContent/bespoke/future-of-voices/newVideo/sarah-bond.mp4",
        poster:"https://www.mckinsey.com/spContent/bespoke/future-of-voices/newVideo/sarah-bond.png",
      },
    ],
    speaker: {
      name: "Sarah Bond",
      job: "Corporate VP and head of gaming, Microsoft",
      fullinterview: "https://www.mckinsey.com/industries/technology-media-and-telecommunications/our-insights/game-on-an-interview-with-microsofts-head-of-gaming-ecosystem",
      customlink:"Hear more from Sarah",
    },
    clauses: [
      [
        "The work that we’re doing—democratizing development tools, making it possible for people to play and experience more stories and games—has limitless impact on what our society will become. I want my children to walk into a world that is different than the one that I walked into, as I want the same for yours.",
        21*1000,
      ],
    ],
    words: sarah
  },
  {
    id: "jeffrey",
    sources: [
      {
        type: "video/mp4",
        src: "https://www.mckinsey.com/spContent/bespoke/future-of-voices/newVideo/jeffrey-hirsch-new.mp4",
        poster:"https://www.mckinsey.com/spContent/bespoke/future-of-voices/newVideo/jeffrey-hirsch.png",
      },
    ],
    speaker: {
      name: "Jeffrey Hirsch",
      job: "President and CEO, Starz",
      fullinterview: "https://www.mckinsey.com/industries/technology-media-and-telecommunications/our-insights/the-future-of-streaming-and-diverse-content-starz-ceo-jeffrey-hirsch-weighs-in",
      customlink:"Hear more from Jeffrey",
    },
    clauses: [
      [
        "You’re starting to see this today: as technology shrinks the world, it’s really becoming one global marketplace for content. So I think you’ll have, by 2030, content without borders, so to speak. You’ll have content that will come from any part of the world that will be available to consumers all over the world.",
        18*1000,
      ],
    ],
    words: jeffrey
  },
  {
    id: "deb",
    sources: [
      {
        type: "video/mp4",
        src: "https://www.mckinsey.com/spContent/bespoke/future-of-voices/newVideo/deb-roy-v4.mp4",
        poster:"https://www.mckinsey.com/spContent/bespoke/future-of-voices/newVideo/deb-roy-poster.png",
      },
    ],
    speaker: {
      name: "Deb Roy",
      job: "Director, MIT Center for Constructive Communication",
      fullinterview: "https://www.mckinsey.com/industries/technology-media-and-telecommunications/our-insights/the-data-driven-future-of-storytelling-mits-deb-roy-on-the-message-and-the-medium",
      customlink:"Hear more from Deb",
    },
    clauses: [
      [
        "It seems like we’re on a path toward a kind of cultural fragmentation that is unstoppable. There will be stories and forms of entertainment that may be in the English language but incomprehensible across groups—a kind of ‘inside speak.’ That’s one possibility nine years out.",
        19*1000,
      ],
    ],
    words: deb
  },
  {
    id: "stacey",
    sources: [
      {
        type: "video/mp4",
        src: "https://www.mckinsey.com/spContent/bespoke/future-of-voices/newVideo/stacey-sher.mp4",
        poster:"https://www.mckinsey.com/spContent/bespoke/future-of-voices/newVideo/stacey-sher.png",
      },
    ],
    speaker: {
      name: "Stacey Sher",
      job: "Film and TV producer",
      fullinterview: "https://www.mckinsey.com/industries/technology-media-and-telecommunications/our-insights/stacey-sher-on-the-future-of-movies-and-streaming",
      customlink:"Hear more from Stacey",
    },
    clauses: [
      [
        "I hope that, in 2030, the process of going to a film becomes even more communal, more of a hub, and more of a community—because I think the more we become device-heavy, the more disconnected we become. And I think that storytelling is about generating empathy.",
        22*1000,
      ],
    ],
    words: stacey
  },
];

export default videos;